import { CargoType, CarrierType, CarrierVisitStatus } from '@planning/app/api'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import {
  getVisitDashboardGeneralCargoInfoByOrders,
  getVisitDashboardUnitInfoByOrders,
} from '@planning/utils/order-utils'
import { useTranslate } from '@tolgee/react'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { VisitDashboardDirectionCard } from './VisitDashboardDirectionCard'

interface Props {
  restows: IOrderItem[]
  cargoType?: CargoType
  visitId?: number
  visitType?: CarrierType
  visitStatus?: CarrierVisitStatus
  isMinimalisticView?: boolean
  isTallyPage?: boolean
  onViewClick?: () => void
}
export const RestowDetailsDashboardCard = observer(
  ({
    restows,
    cargoType,
    visitId,
    visitType,
    visitStatus,
    isMinimalisticView,
    isTallyPage,
    onViewClick,
  }: Props) => {
    const { t } = useTranslate()

    const { totalDefinition, archetypeGroups } = computed(() => {
      if (cargoType && cargoType === CargoType.GeneralCargo) {
        return {
          totalDefinition: getVisitDashboardGeneralCargoInfoByOrders(restows).totalDefinition,
          archetypeGroups: [],
        }
      } else {
        return getVisitDashboardUnitInfoByOrders(restows)
      }
    }).get()

    return (
      <VisitDashboardDirectionCard
        title={t('restow', 'Restow')}
        cargoType={cargoType}
        visitId={visitId}
        visitType={visitType}
        visitStatus={visitStatus}
        isTallyPage={isTallyPage}
        archetypeGroups={archetypeGroups}
        totalDefinition={totalDefinition}
        isMinimalisticView={isMinimalisticView}
        onViewClick={onViewClick}
      />
    )
  },
)
